import { IUserStateForAnalytics } from "@letshang/constants"
import { get } from "lodash-es"
import { atom } from "recoil"
import { setRecoil } from "recoil-nexus"
import { recoilPersist } from "recoil-persist"

import { getUserInfo } from "@api/firebaseWrappedApis"

const { persistAtom } = recoilPersist()

export const defaultUser = {
  phone: "",
  firstName: "",
  lastName: "",
  dob: "",
  gender: "",
  isOnboarded: false,
  isLoggedIn: false,
  feature_flags: {},
}

export const screenState = atom({
  key: "screenState",
  default: 1,
  effects_UNSTABLE: [persistAtom],
})

export const userState = atom({
  key: "userState",
  default: defaultUser,
  effects_UNSTABLE: [persistAtom],
})

export const userStateForAnalytics = atom<IUserStateForAnalytics>({
  key: "userStateForAnalytics",
  default: { userId: null, isAnonymous: true },
})

export const updateUserStateFromBackend = async () => {
  const userInfo = (await getUserInfo({})) as any
  const currentUserInfo = get(userInfo, "userInfo")

  setRecoil(userState, (prev) => ({
    ...prev,
    ...currentUserInfo,
  }))
}
